import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import NotFoundComponent from './views/NotFound.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/index.html', redirect: { name: 'home' }
    },
    {
      path: '/event/:id/',
      name: 'event',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/Event.vue')
    },
    {
      path: '/event/:id/:page/',
      name: 'eventpage',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/Event.vue')
    },{
      path: '*',
      name: 'empty',
      component: NotFoundComponent
    }
  ]
})
